<template>
<div class="chapter">
<div class="inner_page">
<p class="half-title" id="page_xxx"><img alt="Half Title of Europe and the Jews" src="images/29.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_Halftitle.vue?9256795a